import orderApi from '@/api/order'

const state = {
  orderId: null,
  events: [],
  loading: false,
  loaded: false,
  error: null,
}

const getters = {}

const actions = {
  async fetchHistory({ commit }, id) {
    commit('SET_LOADING', id)
    try {
      const { data } = await orderApi.getStatusHistory(id)
      commit('SET_HISTORY', { id, events: data })
    } catch (error) {
      commit('SET_ERROR', {
        id,
        text: error.response?.data?.message || 'Не удалось прочитать историю статусов',
      })
    }
  },
}

const mutations = {
  SET_LOADING(state, id) {
    if (state.orderId !== id) {
      state.events = []
      state.loaded = false
      state.error = null
    }

    state.orderId = id
    state.loading = true
  },

  SET_HISTORY(state, { id, events }) {
    if (state.orderId !== id) return

    state.events = Array.isArray(events) ? events : []
    state.error = null
    state.loading = false
    state.loaded = true
  },
  SET_ERROR(state, { id, text }) {
    if (state.orderId !== id) return

    state.events = []
    state.error = text
    state.loading = false
    state.loaded = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
